import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { feedAuditPlatformSearchSchema } from '~/features/feed-audit/constants/feed-audit-platform';
import { requireTenantAdmin } from '~/utils/guards';

const FeedAuditUploadPage = lazy(
  () => import('~/features/feed-audit/pages/feed-audit-upload-page'),
);

// Uploading a file starts a run — subsidiary/super-admin only, like `create`.
export const Route = createFileRoute('/_authenticated/_tenant/feed-audit/upload')({
  // `?platform=google|meta` picks the channel the audit runs for (default Google).
  validateSearch: feedAuditPlatformSearchSchema,
  beforeLoad: requireTenantAdmin('/feed-audit'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FeedAuditUploadPage />
    </Suspense>
  ),
});
